import { dao } from '@platform/dao';
import type { ICustomModuleCreated } from '@platform/dao';
import type { ICustomModuleArg } from './args/ICustomModuleArg';
import { baseApi, run } from './baseApi';
import { moduleTag } from './moduleTag';

/**
 * Власні модулі робочого простору (ADR-025; конструктор модулів прототипу v4 newModule / deleteModule): створення, зміна визначення
 * (назва, однина, префікс, категорія, опис) і видалення разом із записами. Каталоги й визначення перечитуються (новий модуль з'являється в
 * меню груп, «Усіх модулях», навігаторі й «Налаштуваннях»); видалення ще й скидає списки, записи, зв'язки й зведення.
 */
export const customModulesApi = baseApi.injectEndpoints({
  endpoints: (b) => ({
    createCustomModule: b.mutation<ICustomModuleCreated, ICustomModuleArg>({
      queryFn: ({ ws, body }) => run(() => dao.customModules.create(ws, body ?? {})),
      invalidatesTags: ['Catalog'],
    }),
    updateCustomModule: b.mutation<unknown, ICustomModuleArg>({
      queryFn: ({ ws, key, body }) => run(() => dao.customModules.update(ws, key ?? '', body ?? {})),
      invalidatesTags: (_r, _e, { ws, key }) => ['Catalog', moduleTag(ws, key ?? '')],
    }),
    deleteCustomModule: b.mutation<void, ICustomModuleArg>({
      queryFn: ({ ws, key }) => run(() => dao.customModules.remove(ws, key ?? '')),
      // визначення видаленого модуля не перечитується (його вже немає — 404), лише каталоги, списки, записи й зведення
      invalidatesTags: ['Catalog', 'RecordList', 'Record', 'Stats', 'Links', 'Assignments', 'Recent', 'Favourites', 'Inbox'],
    }),
  }),
});

export const { useCreateCustomModuleMutation, useUpdateCustomModuleMutation, useDeleteCustomModuleMutation } = customModulesApi;
